import type { SvgIconComponent } from "@mui/icons-material";
import AppsOutlinedIcon from "@mui/icons-material/AppsOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import CancelScheduleSendOutlinedIcon from "@mui/icons-material/CancelScheduleSendOutlined";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import type { Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

import type { FluxmedDefaultTemplateCategory } from "./messageTemplateUiUtils";

type CategoryChipColor = "primary" | "warning" | "success" | "info" | "default";

interface FluxmedDefaultCategoryConfig {
  Icon: SvgIconComponent;
  chipColor: CategoryChipColor;
  resolveAccent: (theme: Theme) => string;
}

const CATEGORY_CONFIG: Record<FluxmedDefaultTemplateCategory, FluxmedDefaultCategoryConfig> =
  {
    agendamento: {
      Icon: CalendarMonthOutlinedIcon,
      chipColor: "info",
      resolveAccent: (theme) => theme.palette.info.main,
    },
    cancelamento: {
      Icon: CancelScheduleSendOutlinedIcon,
      chipColor: "warning",
      resolveAccent: (theme) => theme.palette.warning.main,
    },
    pagamento: {
      Icon: PaymentsOutlinedIcon,
      chipColor: "success",
      resolveAccent: (theme) => theme.palette.success.main,
    },
    outros: {
      Icon: MoreHorizOutlinedIcon,
      chipColor: "default",
      resolveAccent: (theme) => theme.palette.grey[600],
    },
  };

export function getFluxmedDefaultCategoryIcon(
  category: FluxmedDefaultTemplateCategory | "all",
): SvgIconComponent {
  if (category === "all") return AppsOutlinedIcon;
  return CATEGORY_CONFIG[category].Icon;
}

export function getFluxmedDefaultCategoryChipColor(
  category: FluxmedDefaultTemplateCategory | "all",
): CategoryChipColor {
  if (category === "all") return "default";
  return CATEGORY_CONFIG[category].chipColor;
}

export function getFluxmedDefaultCategoryAccent(
  category: FluxmedDefaultTemplateCategory,
  theme: Theme,
): { main: string; lightBg: string } {
  const main = CATEGORY_CONFIG[category].resolveAccent(theme);
  return {
    main,
    lightBg: alpha(main, 0.14),
  };
}
